import Login from './Login';
import Logout from './Logout';
import Register from './Register';
import VerifyEmail from './VerifyEmail';
import Forgotpass from './ForgotPass';
import Resetpass from './ResetPass';
import SetPassword from './SetPassword';
import SetPhoneAfterSocialAuth from './SetPhoneAfterSocialAuth';
import AmzSignin from './AmzSignin';

export default {
  login: Login,
  logout: Logout,
  register: Register,
  forgotpass: Forgotpass,
  resetpass: Resetpass,
  verifyEmail: VerifyEmail,
  setPassword: SetPassword,
  setPhoneAfterSocialAuth: SetPhoneAfterSocialAuth,
  amzSignin: AmzSignin,
};
